"use strict";

var _interopRequireDefault = require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/vescort-platform-pc-website/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _sideNav = _interopRequireDefault(require("@/components/side-nav.vue"));
var _footNav = _interopRequireDefault(require("@/components/foot-nav.vue"));
var _appCitysData = _interopRequireDefault(require("@/assets/static/js/citys/app.citys.data.js"));
var _listRow = _interopRequireDefault(require("../../../components/cooperationMall/listRow"));
var _noImgListRow = _interopRequireDefault(require("../../../components/cooperationMall/noImgListRow"));
var _avatarListRow = _interopRequireDefault(require("../../../components/cooperationMall/avatarListRow"));
var _leftImgListRow = _interopRequireDefault(require("../../../components/cooperationMall/leftImgListRow"));
var _paging = _interopRequireDefault(require("@/components/paging"));
var _dicDataApi = require("../../../api/dicDataApi");
var _util = require("../../../assets/static/js/utils/util");
var _api = _interopRequireDefault(require("../../../api/api"));
var _elementUi = require("element-ui");
var _default = exports.default = {
  components: {
    sideNav: _sideNav.default,
    footNav: _footNav.default,
    paging: _paging.default,
    listRow: _listRow.default,
    noImgListRow: _noImgListRow.default,
    avatarListRow: _avatarListRow.default,
    leftImgListRow: _leftImgListRow.default
  },
  data: function data() {
    return {
      name: '',
      classifyNameArr: ['招聘', '求职', '买车', '卖车', '产废', '处废'],
      classifyCodeArr: ['ZP', 'QZ', 'MMC', 'MC', 'CF', 'CCF'],
      // MC:卖车,CF:产废
      routeNameArr: ['mallZpList', 'mallMmList', 'mallCzList'],
      unSupportCitysArr: ['台湾', '香港特别行政区', '澳门特别行政区', '钓鱼岛'],
      classifyData: [],
      activeClassifyItem: {},
      // 选中的分类对象(分类id,分类code,分类name)
      cityData: _appCitysData.default.cityDataWithoutDistrict,
      address: [],
      // 地址
      sortTypeData: [{
        name: '综合排序',
        index: 0
      }, {
        name: '最新发布',
        index: 1
      }],
      queryDayData: [{
        name: '1天内',
        index: 1
      }, {
        name: '7天内',
        index: 7
      }, {
        name: '14天内',
        index: 14
      }, {
        name: '30天内',
        index: 30
      }],
      searchParams: {
        keyword: '',
        // 搜索关键词
        plateId: '',
        // 板块ID
        classifyId: '',
        // 分类ID
        merchantStatus: '',
        // 是否为精选推荐(0:否,1:是)
        sortType: 0,
        // 排序方式(0:综合排序,1:最新发布,2:离我最近(直接查询province、city)。默认的是综合排序来查询)
        queryDay: '',
        // 查询的天数(1:一天内,7:7天内,14:14天内,30:30天内)
        province: '',
        // 省份
        city: '',
        // 城市
        pageSize: 10,
        pageNo: 1
      },
      listData: [],
      dictsData: null,
      listTotalCount: 0,
      showAppDialog: false,
      loaded: false,
      searchDisabled: false
    };
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (window.localStorage.getItem('dics')) {
              _context.next = 8;
              break;
            }
            _context.next = 3;
            return (0, _dicDataApi.getDictsData)();
          case 3:
            this.dictsData = _context.sent;
            _context.next = 6;
            return (0, _dicDataApi.getGoodsTypeData)();
          case 6:
            this.dictsData['GOODS_TYPE'] = _context.sent;
            localStorage.setItem('dics', JSON.stringify(this.dictsData));
          case 8:
            _context.next = 10;
            return this.toGetPlateclassify();
          case 10:
            // this.activeClassifyItem = this.classifyData[0]
            this.activeClassifyItem = this.classifyData[this.$route.query.classifyIndex];
            this.searchParams.classifyId = this.classifyData[this.$route.query.classifyIndex].classifyId;
            _context.next = 14;
            return this.getClassifyId();
          case 14:
            this.getPageMerchantInfoList();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  watch: {
    $route: function () {
      var _$route = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(to, from) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(to.path != from.path)) {
                _context2.next = 5;
                break;
              }
              // 同一页面且路由变化时,重置pageNo,获取当前服务类型,更新列表数据
              this.searchParams.pageNo = 1;
              _context2.next = 4;
              return this.getClassifyId();
            case 4:
              this.getPageMerchantInfoList();
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function $route(_x, _x2) {
        return _$route.apply(this, arguments);
      }
      return $route;
    }()
  },
  methods: {
    // 去求职详情页
    toDetail: function toDetail(id, item) {
      console.log('id', id);
      console.log('item', item);
      switch (item.classifyCode) {
        case "MC":
          this.$router.push({
            name: 'sellDetail',
            query: {
              merchantId: id
            }
          });
          break;
        case "MMC":
          this.$router.push({
            name: 'boughtDetail',
            query: {
              merchantId: id
            }
          });
          break;
        case "QZ":
          this.$router.push({
            name: 'qzDetail',
            query: {
              merchantId: id
            }
          });
          break;
        case "ZP":
          this.$router.push({
            name: 'zpDetail',
            query: {
              merchantId: id
            }
          });
          break;
        case "CCF":
          this.$router.push({
            name: 'dealWasteDetail',
            query: {
              merchantId: id
            }
          });
          break;
        case "CF":
          this.$router.push({
            name: 'needWasteDetail',
            query: {
              merchantId: id
            }
          });
          break;
        default:
          break;
      }
    },
    // 默认头像随机
    userNormalImg: function userNormalImg() {
      var ico = '';
      if (this.$root.comAvatarArr) {
        ico = this.$root.comAvatarArr[Math.floor(Math.random() * this.$root.comAvatarArr.length)];
      }
      return ico;
    },
    // 服务类别
    classifyChange: function classifyChange(val) {
      this.listData = [];
      this.searchParams.classifyId = val.classifyId;
      Object.assign(this.activeClassifyItem, val);
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 排序
    sortTypeChange: function sortTypeChange(val) {
      this.searchParams.sortType = val;
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 地址
    addressChange: function addressChange(value) {
      if (value.length > 0) {
        if (this.unSupportCitysArr.includes(value[0])) {
          this.$message({
            message: '该地区业务还未开展',
            type: 'warning'
          });
          this.address = [];
          this.searchParams.province = '';
          this.searchParams.city = '';
          value = [];
          this.searchParams.pageNo = 1;
          this.getPageMerchantInfoList();
          return;
        } else {
          this.searchParams.province = value[0];
          this.searchParams.city = value[1].indexOf('全省') >= 0 ? '' : value[1];
          this.searchParams.pageNo = 1;
          this.getPageMerchantInfoList();
        }
      } else {
        this.searchParams.province = '';
        this.searchParams.city = '';
        this.searchParams.pageNo = 1;
        this.getPageMerchantInfoList();
      }
    },
    // 发布时间
    queryDayChange: function queryDayChange(val) {
      this.searchParams.queryDay = val;
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 搜索关键词
    toSearch: function toSearch() {
      this.searchDisabled = true;
      this.searchParams.pageNo = 1;
      this.getPageMerchantInfoList();
    },
    // 分页切换
    pageChange: function pageChange(value) {
      this.searchParams.pageNo = value.curPage;
      this.getPageMerchantInfoList();
    },
    // 引导下载弹窗
    toShowPopup: function toShowPopup() {
      this.showAppDialog = true;
    },
    // 格式化板块分类数据
    formatClassifyData: function formatClassifyData(data) {
      var _this = this;
      if (data) {
        data.filter(function (item) {
          if (item.plateClassifies && item.plateClassifies.length > 0) {
            item.plateClassifies.filter(function (pcItem) {
              if (pcItem && _this.classifyCodeArr.includes(pcItem.classifyCode)) {
                _this.classifyData.push(pcItem);
              }
            });
          }
        });
      }
    },
    /********************************************** Request **********************************************************/
    // 查询版块分类
    toGetPlateclassify: function () {
      var _toGetPlateclassify = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var loadInstance, _yield$Api$apiGetPlat, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.classifyData = [];
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              _context3.next = 4;
              return _api.default.apiGetPlateclassify((0, _util.getParams)('getplateclassify', {}));
            case 4:
              _yield$Api$apiGetPlat = _context3.sent;
              data = _yield$Api$apiGetPlat.data;
              loadInstance.close();
              if (data.proCode == '200') {
                if (data.proData.length > 0) {
                  this.loaded = true;
                  this.formatClassifyData(data.proData);
                }
              }
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function toGetPlateclassify() {
        return _toGetPlateclassify.apply(this, arguments);
      }
      return toGetPlateclassify;
    }(),
    // 列表查询接口
    getPageMerchantInfoList: function () {
      var _getPageMerchantInfoList = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var loadInstance, _yield$Api$apiGetPage, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              loadInstance = _elementUi.Loading.service({
                background: 'rgba(0, 0, 0, 0.5)'
              });
              _context4.next = 3;
              return _api.default.apiGetPageMerchantInfoList((0, _util.getParams)('pageMerchantInfoList', this.searchParams));
            case 3:
              _yield$Api$apiGetPage = _context4.sent;
              data = _yield$Api$apiGetPage.data;
              loadInstance.close();
              this.searchDisabled = false;
              if (!(data.proCode == '200')) {
                _context4.next = 17;
                break;
              }
              console.log("getPageMerchantInfoList:", data.proData);
              this.listTotalCount = data.proData.count;
              if (!(data.proData.dataList.length > 0)) {
                _context4.next = 16;
                break;
              }
              _context4.next = 13;
              return this.formatListItem(data.proData.dataList);
            case 13:
              this.listData = _context4.sent;
              _context4.next = 17;
              break;
            case 16:
              this.listData = [];
            case 17:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getPageMerchantInfoList() {
        return _getPageMerchantInfoList.apply(this, arguments);
      }
      return getPageMerchantInfoList;
    }(),
    // 将列表字段格式化
    formatListItem: function formatListItem(listData) {
      var _this2 = this;
      var dataArr = listData;
      if (this.activeClassifyItem.classifyCode == 'ZP' || this.activeClassifyItem.classifyCode == 'QZ') {
        dataArr = listData.filter(function (item) {
          // if(!item.ossHeadUrl) item.ossHeadUrl = this.userNormalImg()
          (0, _util.getJobDictItemName)(item);
          return item;
        });
      } else if (this.activeClassifyItem.classifyCode == 'MMC' || this.activeClassifyItem.classifyCode == 'MC') {
        dataArr = listData.filter(function (item) {
          // if(!item.ossHeadUrl) item.ossHeadUrl = this.userNormalImg()
          (0, _util.getCarDictItemName)(item);
          return item;
        });
      } else {
        dataArr = listData.filter(function (item) {
          if (!item.ossHeadUrl) item.ossHeadUrl = _this2.userNormalImg();
          return item;
        });
      }
      return dataArr;
    },
    // 根据路由获取分类id
    getClassifyId: function getClassifyId() {
      var _this3 = this;
      if (this.$route.path.indexOf('cooperationMall') >= 0) {
        var routeName = this.$route.name;
        if (this.routeNameArr.includes(routeName) && this.classifyData.length > 0) {
          this.classifyData.filter(function (item) {
            if (routeName == 'mallZpList' && item.classifyCode == 'ZP') {
              _this3.searchParams.classifyId = item.classifyId;
              _this3.activeClassifyItem = item;
            }
            if (routeName == 'mallMmList' && item.classifyCode == 'MC') {
              _this3.searchParams.classifyId = item.classifyId;
              _this3.activeClassifyItem = item;
            }
            if (routeName == 'mallCzList' && item.classifyCode == 'CF') {
              _this3.searchParams.classifyId = item.classifyId;
              _this3.activeClassifyItem = item;
            }
            console.log("routeName:", routeName);
          });
        }
      }
    }
  }
};